<template>
  <div id="container" class="flex_one">
    <div class="list_box full_layout" >
      <div class="list_left_box">
        <div class="tac">
          <el-collapse v-model="activeNames" class="seach_list_left">
            <el-collapse-item name="1">
              <template slot="title">
                {{ $t('base.category') }}
              </template>
              <div v-if="Category.length>0">
                <div class="CategoryList" v-for="(item,index) in Category" :key="index" :class="firstCategoryId==item.id?'on':'on'">
                  <div class="CategoryFirstTitle">{{ $store.state.lang != 'zh-tw' ? item.EnName : item.label }}</div>
                  <div class="CategoryFirstDetail" v-for="(it,i) in item.children" :key="i" :class="[secondCategoryId==it.id?'on':'',secondCategoryIdarray[i]['isType']?'ov':'']">
                    <div class="CategorySecTitle" @click="isCategory(it.id,'s',i)">{{ $store.state.lang != 'zh-tw' ? it.EnName : it.label }}</div>
                    <ul class="CategorySecDetail">
                      <li v-for="(res,j) in it.children" :key="j" :class="thirdCategoryId==res.id?'on':''">
                        <router-link :to="{path:'/market',query:{type:'category',f:res.Fid,s:res.Sid,t:res.id,key:searchKey}}">{{ $store.state.lang != 'zh-tw' ? res.EnName : res.label }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- :default-expanded-keys="expandedKeys" -->
              <!-- <div v-if="Category.length>0">
                <el-tree :data="Category" ref="tree" node-key="id" :current-node-key="thirdCategoryId" :default-checked-keys="thirdCategoryIdarray" :accordion="true" :default-expanded-keys="expandedKeys" :props="defaultProps" @node-click="treeChange"></el-tree>
              </div> -->
            </el-collapse-item>
            <el-collapse-item :name="Number(index+2)" v-for='(item,index) in checkList' :key='index'>
              <template slot="title">
                {{$store.state.lang != 'zh-tw' ? item.Property.EnName : item.Property.ChName}}
              </template>
              <div>
                <el-checkbox-group v-model="sportslist[item.Property.ControlName]" @change='checkboxChange'>
                  <div v-for="(res,i) in item.PropertyKeyValues" :key="i">
                    <el-checkbox :label="res" v-show="isSports[item.Property.EnName]?item.PropertyKeyValues.length:(i<5)">{{ $store.state.lang != 'zh-tw' ? res.EnName : res.ChName}}
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
                <div class="catalogue_a_color" v-if="item.PropertyKeyValues.length>5" @click="setIsSports(item.Property.EnName)">
                  {{ isSports[$store.state.lang != 'zh-tw' ? item.Property.EnName : item.Property.ChName] ? '' : $t('base.seeAll') }}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
      <div class="list_right_box">
        <!-- <div class="results_box" v-if="searchKey!=null">
          <span class="results_amount">{{TotalCount}}</span>
          <span class="results">results for</span>
          <span class="results_elite">donruss elite</span>
        </div> -->
        <div class="all_item">
          <div class="flex_layout_between">
            <div class="seller_tab">
              <span class="" v-if='searchKey!=null' :class="isSort == 0 ? 'on' : ''" @click="SellerSort(0)">{{$t('base.bestMatch')}}</span>
              <el-divider v-if="searchKey!=null" direction="vertical"></el-divider>
              <span class="" :class="isSort == 1 ? 'on' : ''" @click="SellerSort(1)">{{Status=='1'?$t('enum.endingSoonest'):$t('enum.endingRecently')}}</span>
              <el-divider direction="vertical"></el-divider>
              <span class="sort_price" :class="isSort == 2 ? 'on' : ''" @click="SellerSort(2)">
                {{ $t('base.price') }}
                <em class="up_arr" :class="isPrice ? 'up' : ''"></em>
                <em class="up_down" :class="!isPrice && isPrice != null ? 'up' : ''"></em>
              </span>
              <el-divider direction="vertical"></el-divider>
              <span class="" :class="isSort == 3 ? 'on' : ''" @click="SellerSort(3)">{{ $t('base.newly') }}</span>
              <el-divider v-if='isAuction' direction="vertical"></el-divider>
              <span v-if='isAuction' class="" :class="isSort == 4 ? 'on' : ''" @click="SellerSort(4)">{{ $t('base.mostBids') }}</span>
            </div>
            <div class="seller_select">
              <el-select class="select_seller all_listings" v-model="listings" @change="getSelect('listings')">
                <el-option v-for="(item, index) in all_listings" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select class="select_seller all_status" v-model="Status" @change="getSelect('Status')">
                <el-option v-for="(item, index) in all_Status" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <el-select v-if="isGraded" class="select_seller" v-model="Graded" @change="getSelect('Graded')">
                <el-option v-for="(item, index) in all_Graded" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <el-skeleton :count="12" animated class="thousand_layout skull" :loading="loading">

          <template slot="template">
            <list-skeleton />
          </template>
          <template>
            <goods-list class="thousand_layout" :StatusNum="Status" :list="list" type="search" />
          </template>
        </el-skeleton>
            
            <!-- <goods-list class="thousand_layout" :StatusNum="Status" :list="list" type="search" /> -->
        <list-pagination class="full_layout" :TotalCount="TotalCount" :ps="ps" @ps='pageSize' @pi='pageIndex' v-if="!ifData" />
        <n-o-t-n class="notfind" title="" :text="$t('base.noData')" v-else-if="resultTpye==1" />
        <f-z-f class="notfind" title="" :text="$t('base.pagefault')" v-else />
      </div>
    </div>
  </div>
</template>
<script>
import { getInfo, resetCategory, getCategory, CookiesCategory } from "@/api/public";
import GoodsList from "@/components/list/goods";
import ListPagination from "@/components/listpagination";
import NOTN from "@/components/notnull.vue";
import ListSkeleton from "@/components/skeleton.vue";
import FZF from "@/components/404.vue";
export default {
  name: "index",
  components: { GoodsList, ListPagination, NOTN, FZF,ListSkeleton },
  data() {
    return {
      userInfo: '',
      searchKey: '',
      resultTpye: '',
      sort: 'EffectiveTimeStamp',
      sortType: 'asc',
      Category: [],
      expandedKeys: [],
      thirdCategoryIdarray: [],
      firstCategoryId: '',
      secondCategoryId: '',
      secondCategoryIdarray: [],
      thirdCategoryId: "",
      activeNames: ['1'],
      defaultactive: '',
      checkList: [],
      sportslist: '',
      radiosportslist: '',
      sportsKeys: this.$enumInfo.PropertyList,
      isSports: '',
      loading: false,
      isType: '',
      isSportsId: '',
      //auction拍卖：2、buy it now一口价：1->ByWay accept offers可议价：1->Bargain Status是selling出售中1、sold出售的-2{ "Key": "ByWay", "Value": "" }, { "Key": "Bargain", "Value": "" },
      buway: [],
      CategoryKeys: [{ "Key": "Status", "Value": 1 }],
      SeachJson: [],
      ifData: false,
      list: {},
      defaultProps: {
        children: "children",
        label: "EnName",
      },
      isSort: 1,
      isPrice: null,
      isAuction: true, // 是否拍卖
      isGraded: false, // 是否评分
      listings: "0",
      Status: '1',
      isTabSold:{
        'selling':1,
        'sold':3
      },
      Graded: "0",
      all_Sort: this.$enumInfo.searchSort,
      all_listings: this.$enumInfo.listings,
      all_Status: this.$enumInfo.status,
      all_Graded: this.$enumInfo.graded,
      ps: 60, //pagesize
      pi: 1, //pageindex
      TotalCount: 0,
    };
  },
  watch: {
    '$route': 'getPath'
  },
  created() {
    this.getPath()
    let that = this;
    this.userInfo = getInfo();
    this.isType = this.$route.query.type;
    this.getCategoryList();
    // console.log('this.Status',this.Status)

    /**默认展开Sport Cards**/
    //that.getCategorykey('4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de', '4f55c5c0-a4e4-4bb2-b0f0-fef5a093e0de');
  },
  mounted() {
    this.$root.$on("newSearch", val => {
      this.searchKey = val || null;
    })
    this.getCategoryList();
  },
  // beforeRouteUpdate(to, from, next) {
  //   console.log(to)
  //   let that = this;
  //   this.userInfo = getInfo();
  //   that.getCategoryList();
  //   this.isType = to.query.type;
  //   if (this.isType == "GameComic" || this.isType == "Sports" || this.isType == "Graded" || this.isType == "Card" || this.isType == "category" || this.isType == null) {
  //     this.isSportsId = this.$route.query.id;
  //     that.getCategorykey(to.query.principalId, to.query.secondaryId);
  //     that.getThirdCategoryId(to.query.secondaryId);
  //   } else {
  //     that.expandedKeys = ['dee8e93d-bf0d-46d7-a817-45db58756940']

  //     that.thirdCategoryIdarray = ['dee8e93d-bf0d-46d7-a817-45db58756940']
  //     that.getType(this.isType);
  //   }
  //   next()
  // },
  methods: {

    getPath() {
      this.searchKey = this.$route.query.key || null;
      console.log('this.searchKey', this.searchKey)
      let that = this;
      this.userInfo = getInfo();
      this.isType = this.$route.query.type;
      this.getCategoryList();
      console.log('this.isType', this.isType)
      if (this.isType == "GameComic" || this.isType == "Sports" || this.isType == "Graded" || this.isType == "Card" || this.isType == "category" || this.isType == null) {
        this.$root.$emit("newSearch", this.searchKey);
        this.isSportsId = this.$route.query.id;
        this.getCategorykey(this.$route.query.f, this.$route.query.s, this.$route.query.t);
        this.getThirdCategoryId(this.$route.query.t);
      } else {
        that.getType(this.isType)
        that.expandedKeys = ['dee8e93d-bf0d-46d7-a817-45db58756940']
        that.thirdCategoryIdarray = ['dee8e93d-bf0d-46d7-a817-45db58756940']
        that.thirdCategoryId = ""
        //that.getCategorykey('dee8e93d-bf0d-46d7-a817-45db58756940', 'dee8e93d-bf0d-46d7-a817-45db58756940');
      }
    },
    Loading(val) {
      this.loading = val
    },
    //获取类目
    getCategoryList() {
      this.Loading(true)
      let that = this
      let array = [];
      let fun = function(res) {
        that.Category = res;
        let s = that.$route.query.s
        res.map(item => {
          item.children.map(it => {
            array.push({ 'id': it.id, isType: (s && s == it.id ? true : false) })
          })
        })
        that.secondCategoryIdarray = array
        //secondCategoryIdarray
      }
      CookiesCategory('get', 'cardCategory', 'shop', fun)
      // getCategory().then(res => {
      //   let data = resetCategory(res.Data);
      //   this.Category = data;
      // })
    },
    // 获取三级类目下的属性 属性：sportslist, 是否多于8条：isSports
    getThirdCategoryId(val) {
      let that = this;
      this.$get(this.$interface.GetKeyValueByThirdCategoryId, { 'thirdCategoryId': val, 'size': '20' }).then(res => {
        if (res.Result != 0) {
          let data = res.Data
          this.checkList = data
          let newArray = {};
          let radionewArray = {};
          let isShow = {};
          let sportItem = "";
          res.Data.map(item => {
            newArray[item.Property.ControlName] = []
            isShow[item.Property.ControlName] = false
            //console.log(item.Property.ControlName,'item.Property.ControlName')
            if (item.Property.ControlName == 'Sports') {
              sportItem = item.PropertyKeyValues;
            }
          })
          //筛选 单卡 sports
          if (this.isType == 'Sports' && this.isSportsId != undefined || this.isType == 'Graded' && this.isSportsId == 'Graded Card') {
            isShow['Sports'] = true;
            sportItem.map(r => {
              console.log(r.EnName, this.isSportsId, '1111')
              if (this.isSportsId.indexOf(r.EnName) != -1) {
                newArray['Sports'].push(r)
              }
            })
            console.log(sportItem, 'sportItem')
            if (this.isSportsId == 'Graded Card') {
              this.activeNames = ['1', 6]
            } else {
              this.activeNames = ['1', 2]
            }
          } else {
            this.activeNames = ['1']
          }
          that.isSports = isShow
          that.sportslist = newArray
          that.radiosportslist = radionewArray;
          that.checkboxChange();
        }
      })
    },
    //SearchCommodity 根据条件获取列表数据
    getDetailList() {
      //sort=EffectiveTimeStamp&sortType=asc
      let that = this;

      that.Loading(true)
      let SeachJson = JSON.stringify(that.SeachJson);
      let sn = window.localStorage.getItem('sn') != null ? window.localStorage.getItem('sn') : '';
      // if (sn != '') {
      //   this.searchKey = sn
      //   this.isSort = 0
      // } else {
      //   this.searchKey = null
      // }
      let data = { userId: '', pageIndex: that.pi, pageSize: that.ps, searchKey: that.searchKey || '', searchJson: SeachJson, sort: that.sort, sortType: that.sortType }
      if (that.userInfo != null) {
        data.userId = that.userInfo.MappingUserId
      }
      console.log(data, 'data')
      this.$get(this.$interface.SearchCommodity, data).then(res => {
        if (res.result != 0) {
          var data = res.data;
          that.pi = parseInt(data.PageIndex)
          that.TotalCount = parseInt(data.TotalCount)
          console.log(that.TotalCount)
          that.list = data.PagedMarketItemList;
          console.log('123', that.list)
          if (that.list.length == 0) {
            this.ifData = true;
          } else {
            this.ifData = false;
          }
        } else {
          this.ifData = true;
        }
        that.resultTpye = res.result
        that.Loading(false)
        //console.log(res)
      }).catch(error => {
        this.Loading(false)
      })
    },
    // 设置默认展开
    getCategorykey(f, s, t) {
      let that = this;
      let fid = f;
      let sid = s;
      let tid = t;
      console.log(fid, sid, tid)
      this.expandedKeys = fid ? [fid] : []
      this.thirdCategoryIdarray = sid ? [sid] : []

      this.firstCategoryId = fid || ''
      this.secondCategoryId = sid || ''
      this.thirdCategoryId = tid || ''
      console.log("getCategorykey", f, s, t);
      // if (fid != undefined && sid != undefined) {
      //   that.expandedKeys = [fid]
      //   that.thirdCategoryId = sid
      //   that.thirdCategoryIdarray = [sid]
      // }
    },
    isCategory(id, type, i) {
      let that = this;
      //this.secondCategoryIdarray[i]=!this.secondCategoryIdarray[i]
      if (type == 's') {
        that.secondCategoryIdarray.map(res => {
          if (res.id == id) {
            res.isType = !res.isType
          }
        })
        that.secondCategoryId = id || ''
      }
    },
    // 获取属性
    checkboxChange() {
      let that = this;
      let cay = []
      let oldRadio = []
      let newCategoryKeys = that.CategoryKeys
      let newbuway = that.buway
      let newArray = [];
      let newRadio = [];

      //console.log('this.isType',this.isType,'this.isSportsId',this.isSportsId)
      if (this.isType == 'Graded' && this.isSportsId == 'Graded Card') {
        // console.log('radiolist111',that.sportslist)
        let radiolist = that.checkList;
        let radioObj = '';
        radiolist.map(res => {
          if (res.Property.ControlName == 'Graded') {
            radioObj = res.PropertyKeyValues
          }
        })
        that.sportslist.Graded = [radioObj[1]]
      }

      let oldArray = that.sportslist
      for (var key in oldArray) {
        if (oldArray[key].length > 0) {
          oldArray[key].map(res => {
            newArray.push({ "Key": key, "Value": res.EnName })
          })
        }
      }
      for (var i in oldRadio) {
        if (oldRadio[i].EnName != undefined) {
          newRadio.push({ "Key": i, "Value": oldRadio[i].EnName })
        }
      }
      //console.log(oldRadio, 'oldRadio')
      //console.log(oldRadio.Graded, 'Graded')
      if (oldRadio.Graded != undefined) {
        that.isGraded = true
        if (oldRadio.Graded.EnName == 'No') {
          that.Graded = '2'
        } else if (oldRadio.Graded.EnName == 'Yes') {
          that.Graded = '1'
        } else {
          that.Graded = '0'
        }
      } else {
        that.isGraded = false
      }
      if (this.isType == 'GameComic') {
        cay.push({ "Key": this.isType, "Value": this.isSportsId })
      }
      // console.log('newRadio:',newRadio)
      // console.log('newCategoryKeys:',newCategoryKeys)
      // console.log('newArray:',newArray)
      // console.log('cay:',cay)
      that.SeachJson = [...newArray, ...newRadio, ...cay, ...newCategoryKeys, ...newbuway, { "Key": "ThirdCategoryId", "Value": that.thirdCategoryId }]
      that.getDetailList();
    },
    // 左边栏 隐藏显示
    setIsSports(val) {
      let that = this;
      if (!that.isSports[val]) {
        that.$set(that.isSports, val, true);
      } else {
        that.isSports[val] = !that.isSports[val];
      }
      //console.log(val, that.isSports[val])
    },
    // select 筛选
    getSelect(val) {
      let that = this;

      this.Loading(true)
      that.pi = 1;
      switch (val) {
        case 'listings':
          that.buway = [];
          if (that.listings == 2 || that.listings == 1) {
            if (that.listings == 2) {
              that.isAuction = true
            } else {
              that.isAuction = false
            }

            that.buway.push({ "Key": "ByWay", "Value": that.listings })
          } else if (that.listings == 3) {
            that.buway.push({ "Key": "Bargain", "Value": 1 })
          } else if (that.listings == 0) {

            that.isAuction = true
            that.buway = [];
          }
          break;
        case 'Status':
          // if (that.Status == 0) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          // } else if (that.Status == 1) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          // } else if (that.Status == 2) {
          //   that.CategoryKeys = [{ "Key": "Status", "Value": -2 }]
          // }

          if (that.Status != 2) {
            that.SellerSort(that.isTabSold.selling,1)
            that.CategoryKeys = [{ "Key": "Status", "Value": 1 }]
          } else{
            that.SellerSort(that.isTabSold.sold,1)
            that.CategoryKeys = [{ "Key": "Status", "Value": -2 }]
            //that.SellerSort(3)
          }
          break;
        case 'Graded':
          let radiolist = that.checkList;
          let radioObj = '';
          radiolist.map(res => {
            if (res.Property.ControlName == 'Graded') {
              radioObj = res.PropertyKeyValues
            }
          })
          if (that.Graded == 0) {
            that.sportslist.Graded = []
          } else if (that.Graded == 1) {
            that.sportslist.Graded = radioObj[1]
          } else if (that.Graded == 2) {
            that.sportslist.Graded = radioObj[0]
          }
          break;

      }
      that.checkboxChange()
    },
    // tab 排序 type 1=>不走获取列表的方法
    SellerSort(val,type) {
      let that = this;
      that.Loading(true)
      that.pi = 1;
      that.isSort = val;
      if(that.Status=='1'){
        that.isTabSold.selling=val
      }else{
        that.isTabSold.sold=val
      }
      if (val == 0) {} {
        that.sort = '';
        that.sortType = '';
      }
      if (val == 1) {
        that.sort = that.all_Sort[0]['val'];
        if(that.Status=='1'){
          that.sortType = that.all_Sort[0]['sortType'];
        }else{
          that.sortType ='DESC'
        }
      }
      if (val == 3) {
        that.sort = that.all_Sort[3]['val']
        that.sortType = that.all_Sort[3]['sortType']
      }
      if (val == 2) {
        that.sort = that.all_Sort[1]['val'];
        that.isPrice = !that.isPrice;
        if (that.isPrice) {

          that.sortType = that.all_Sort[1]['sortType'];
        } else {
          that.sortType = that.all_Sort[2]['sortType'];
        }

      } else {
        that.isPrice = null;
      }
      if (val == 4) {
        let isByWay = 0
        that.sort = that.all_Sort[4]['val'];
        that.sortType = that.all_Sort[4]['sortType'];
        that.buway = []
        that.buway.push({ "Key": "ByWay", "Value": '2' })
        that.listings = '2'
        that.SeachJson.map(res => {
          if (res.Key == 'ByWay') {
            isByWay++;
            res.Value = '2'
          }
        })
        if (isByWay == 0) {
          that.SeachJson = [...that.SeachJson, ...that.buway]
        }
        console.log(that.SeachJson, 'that.SeachJson')
      }
      if(type!=1){
        this.getDetailList();
      }
      
    },
    //获取 排序属性 除"category" "Sports"
    getType(val) {
      let that = this;
      that.buway = []
      // 最新发布，猜你喜欢
      if (val == "like") {
        if (that.searchKey != '' && that.searchKey != null) {
          that.isSort = 0;
          that.sort = ""
          that.sortType = ""
        } else {
          that.isSort = 3;
          that.sort = that.all_Sort[3]['val']
          that.sortType = that.all_Sort[3]['sortType'];
        }
        // 拍卖
      } else if (val == 'auction') {
        that.listings = '2'
        that.buway.push({ "Key": "ByWay", "Value": '2' })
        // 一口价
      } else if (val == 'buy') {
        that.listings = '1'
        that.buway.push({ "Key": "ByWay", "Value": '1' })
      }
      that.thirdCategoryId = ""
      that.expandedKeys = []
      this.activeNames = ['1']
      that.checkList = []
      this.pi = 1;
      that.SeachJson = [...that.CategoryKeys, ...that.buway]
      that.getDetailList();
    },
    // Category list
    treeChange(val) {
      let that = this;

      console.log(val, 'val')
      if (val.Sid) {
        //that.Loading(true)
        that.isType = ''
        that.thirdCategoryId = val.id
        that.thirdCategoryIdarray = [val.id]
        that.expandedKeys = [val.Sid]

        this.$router.push({
          path: '/market',
          query: { type: 'category', p: val.Sid, s: val.id }
        })
        //that.getThirdCategoryId(val.id);
      } else {
        that.expandedKeys = [val.Fid]

      }
    },
    // 每页几条
    pageSize(val) {
      this.ps = val
      this.getDetailList();

    },
    // 页码
    pageIndex(val) {
      this.pi = val
      this.getDetailList();
    },
  },
  //离开页面后清除
  destroyed() {
    window.localStorage.removeItem("sn")
    window.localStorage.removeItem("st")
  }
};

</script>
<style scoped>
@import "../../../static/css/search.css";

</style>



// WEBPACK FOOTER //
// src/pages/list/search.vue